export default __webpack_public_path__ + "static/trailBazarBackground-27d364b1ed2e77e65278a8dcf5287af5.png";